import { Services } from "../../../api/Services";
import { toast } from "react-toastify";
import { BASE_URL_COMPETITION } from "../../../api/Constants";

export const useProgramActions = (programState) => {
  const {
    id,
    currentDay,
    currentweek,
    cday,
    cweek,
    setisLoad,
    setMerge,
    setSelectedExerciseIds,
    setMvideo,
    setSelectWorkout,
    setRemoveMerge,
    setSelectedExerciseremoveIds,
    setMergeId,
    setActionModalMessage,
    setActionButtonTitle,
    setSelectedActionObjType,
    setSelectedActionObj,
    setSelectedActionObj2,
    setConfirmActionModal,
    programmDetail,
    navigate,
    selectedExerciseIds,
    selectedExerciseremoveIds,
    workouts,
    setWorkouts,
    setReorder,
    setWorkIds,
    setSelectedworks,
    setCopyDetail,
    setPvalue,
    workIds,
    selectedworks,
    userinput,
    setUsers,
    setUserinput,
    assign,
    setGroupId,
    selectedusers,
    setSelectedusers,
    usersIds,
    setUsersIds,
    groupId,
    detail,
    assigneDate,
    setShow,
    setAssignDate,
    programs,
    copyDetail
  } = programState;

  // Exercise merge/unmerge handlers
  const handleExerciseClick = (workoutExerciseId) => {
    if (selectedExerciseIds.some(item => item.workout_exercise_id === workoutExerciseId)) {
      setSelectedExerciseIds(prevIds =>
        prevIds.filter(item => item.workout_exercise_id !== workoutExerciseId)
      );
    } else {
      setSelectedExerciseIds(prevIds => [
        ...prevIds,
        { workout_exercise_id: workoutExerciseId }
      ]);
    }
  };

  const handleExerciseClickRemove = (workoutExerciseId) => {
    if (selectedExerciseremoveIds.some(item => item.workout_exercise_id === workoutExerciseId)) {
      setSelectedExerciseremoveIds(prevIds =>
        prevIds.filter(item => item.workout_exercise_id !== workoutExerciseId)
      );
    } else {
      setSelectedExerciseremoveIds(prevIds => [
        ...prevIds,
        { workout_exercise_id: workoutExerciseId }
      ]);
    }
  };

  const openMergeModal = (workoutId) => {
    setMvideo("");
    setMerge(true);
    setSelectWorkout(workoutId);
    setSelectedExerciseIds([]);
  };

  const openRemoveModal = (workid, mergid) => {
    setSelectWorkout(workid);
    setMergeId(mergid);
    setSelectedExerciseremoveIds([]);
    setRemoveMerge(true);
  };

  // Confirmation modal helpers
  const showConfirmModal = (message, buttonTitle, actionType, obj1, obj2) => {
    setActionModalMessage(message);
    setActionButtonTitle(buttonTitle);
    setSelectedActionObjType(actionType);
    setSelectedActionObj(obj1);
    setSelectedActionObj2(obj2);
    setConfirmActionModal(true);
  };

  // Program actions
  const deleteProgram = () => {
    showConfirmModal(
      "Do you want to delete this program?",
      "Delete",
      "delete_program",
      id,
      null
    );
  };

  const duplicateProgram = () => {
    showConfirmModal(
      "Do you want to duplicate this program?",
      "Yes",
      "duplicate_program",
      id,
      null
    );
  };

  // Workout actions
  const deleteWorkout = (workout, day) => {
    showConfirmModal(
      `Do you want to delete ${workout.name}?`,
      "Delete",
      "delete_workout",
      workout,
      day
    );
  };

  const duplicateWorkout = (pid, wid) => {
    showConfirmModal(
      "Do you want to duplicate this workout?",
      "Yes",
      "duplicate_workout",
      pid,
      wid
    );
  };

  // Drag and drop
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reOrderWorkouts = [...workouts];
    const [movedExercise] = reOrderWorkouts.splice(result.source.index, 1);
    reOrderWorkouts.splice(result.destination.index, 0, movedExercise);

    setWorkouts(reOrderWorkouts);
  };

  const reOrderWorkout = async () => {
    const payLoad = {
      program_id: detail?.id,
      workouts: workouts?.map((work, index) => ({
        id: work.id,
        order: index,
      })),
    };
    console.log("Reorder Payload:", payLoad);

    try {
      const result = await Services.reOrderWorkouts(payLoad);
      if (result.status === 200) {
        toast.success(result.data.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });

        setTimeout(() => {
          programmDetail(detail?.id, cday || currentDay, cweek || currentweek);
          setReorder(true);
        }, 1000);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Copy workout functions
  const copyWorkouts = async (programId, workoutIds, week, day) => {
    setisLoad(true);
    try {
      const result = await Services.copyWorkouts(programId, workoutIds, week, day);

      if (result.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setWorkIds([]);
        setSelectedworks([]);
        setCopyDetail([]);
        setPvalue("");
        programmDetail(detail?.id, cday || currentDay, cweek || currentweek);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  const copyWorkoutNow = () => {
    if (workIds.length === 0) {
      toast.error("Please select workouts first", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      copyWorkouts(detail?.id, workIds, cweek, cday);
    }
  };

  // User management
  const handleUserInputChange = async (event) => {
    const newInputValue = event.target.value;
    setUserinput(newInputValue);

    try {
      const result = await Services.getProgrammUsers(newInputValue, 1);
      if (result.status === 200) {
        setUsers(result?.data?.data?.listing);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAssign = (event) => {
    const value = event.target.value;
    programState.setAssign(value);
    if (value === "users") {
      setGroupId("");
    } else {
      setUserinput("");
    }
  };

  const handleGroupChange = (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setGroupId(newSelectedId);
  };

  const toggleUser = (item) => {
    if (selectedusers.includes(item)) {
      setSelectedusers(selectedusers.filter(selectedItem => selectedItem !== item));
      setUsersIds(usersIds.filter(selectedId => selectedId !== item?.id));
    } else {
      setSelectedusers(prevSelectedUsers => [...prevSelectedUsers, item]);
      setUsersIds(prevUsersIds => [...prevUsersIds, item?.id]);
    }
  };

  const toggleWorkout = (item) => {
    if (selectedworks.includes(item)) {
      setSelectedworks(selectedworks.filter(selectedItem => selectedItem !== item));
      setWorkIds(workIds.filter(selectedId => selectedId !== item?.id));
    } else {
      setSelectedworks(prevSelectedUsers => [...prevSelectedUsers, item]);
      setWorkIds(prevUsersIds => [...prevUsersIds, item?.id]);
    }
  };

  // Assignment functions
  const assignUsers = async () => {
    if (assign === "groups" && !groupId) {
      toast.error("Please select a group", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    console.log("Assigning Users:", { id });

    setisLoad(true);
    try {
      const result = await Services.editProgram(
        id,
        detail?.name,
        usersIds?.length > 0 ? usersIds?.join(",") : "",
        detail?.image,
        detail?.desc,
        detail?.video,
        groupId ? groupId : "",
        detail?.is_free,
        detail?.price,
        detail?.lock_future_weeks,
        detail?.community_id,
        assigneDate || detail?.start_progress_date,
        detail?.number_of_weeks
      );

      if (result.status === 200) {
        toast.success("Assigned successfully", {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => {
          programmDetail(id, cday || currentDay, cweek || currentweek);
          setShow(false);
          setAssignDate("");
          setGroupId("");
          setUsersIds([]);
          setUserinput("");
          setUsers([]);
          setSelectedusers([]);
        }, 1000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  // Program copy functions
  const handleProgramChange = (e) => {
    setPvalue(e.target.value);
    getWorkoutsForCopy(e.target.value);
  };

  const getWorkoutsForCopy = (programId) => {
    detailForCopy(programId);
    setSelectedworks([]);
  };

  const detailForCopy = async (program_id, day, week) => {
    setisLoad(true);
    try {
      const result = await Services.getProgrammDetail(program_id, day, week);
      if (result.status === 200) {
        setCopyDetail(result?.data?.data?.workouts);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  // User stats
  const showUserStats = (userId) => {
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/user/${userId}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };

  // Merge exercise API calls
  const mergeExercisesNow = async (data) => {
    if (selectedExerciseIds.length < 2) {
      setSelectedExerciseIds([]);
      toast.error("Please select at least two exercises", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    setisLoad(true);
    try {
      const result = await Services.mergeExercises(data);

      if (result.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1500,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => {
          setMerge(false);
          setSelectedExerciseIds([]);
          setMvideo("");
          setSelectWorkout("");
          programmDetail(id, cday || currentDay, cweek || currentweek);
        }, 1500);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  const removeMergeNow = async (data) => {
    if (selectedExerciseremoveIds.length < 1) {
      setSelectedExerciseremoveIds([]);
      toast.error("Please select at least one exercise", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    setisLoad(true);
    try {
      const result = await Services.mergeExercises(data);

      if (result.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        setTimeout(() => {
          setRemoveMerge(false);
          setSelectedExerciseremoveIds([]);
          setMergeId("");
          setSelectWorkout("");
          programmDetail(id, cday || currentDay, cweek || currentweek);
        }, 1500);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
      setisLoad(false);
    }
  };

  return {
    // Exercise handlers
    handleExerciseClick,
    handleExerciseClickRemove,
    openMergeModal,
    openRemoveModal,
    
    // Program actions
    deleteProgram,
    duplicateProgram,
    
    // Workout actions
    deleteWorkout,
    duplicateWorkout,
    onDragEnd,
    reOrderWorkout,
    
    // Copy functions
    copyWorkoutNow,
    handleProgramChange,
    
    // User management
    handleUserInputChange,
    handleAssign,
    handleGroupChange,
    toggleUser,
    toggleWorkout,
    assignUsers,
    showUserStats,
    
    // Merge functions
    mergeExercisesNow,
    removeMergeNow,
    showConfirmModal
  };
};
